import { useContext, useEffect, useState } from "react"
import { HiOutlineChevronDown } from "react-icons/hi"
import ApiContext from "src/provider/API/call-service"
import { AppLabel, AppText, CustomContainer, FlexRow, Input } from "src/style"
import { ChannelsChart, SessionChart, Table } from "src/component"
import { loginHistoryColumns, loginHistoryData } from "src/utils/tableLayout"
import { MdDateRange } from "react-icons/md"

export const LoginHistory: React.FC = () => {
    const {API} = useContext(ApiContext)
    const [loginHistories, setLoginHistories] = useState<Array<any>>([])
    const [date, setDate] = useState('1999-00-00')

    useEffect(() => {
        handleFetchLoginHistories()
    }, [])

    async function handleFetchLoginHistories () {
        const response = await API.getLoginHistories()
        if (response) setLoginHistories(response)
    }

    return (
        <CustomContainer>
            <FlexRow justifyContent="space-between" topMargin="3">
                <AppText textSize="1.8" fontWeight="700" color="#27272E">Login History</AppText>
                <CustomContainer 
                    width='22.6' radius='0.4' borderColor='#E2E8F0' 
                    leftPadding='1' rightPadding='1'
                    bgColor='#ffffff' leftMargin='1.5'
                >
                    <FlexRow height='4' justifyContent='space-between'>
                        <input 
                            className='date-input-hack' id='date' 
                            type='date' 
                            onChange={(e) => setDate(e.target.value)} 
                            autoComplete="off"
                        />
                        <MdDateRange style={{fontSize: '2rem', color: '#4C6FFF'}} />
                        <AppLabel 
                            textSize='1.2' color='#718096' leftPadding='1' 
                            topPadding='0.7' htmlFor='date'
                        >
                            {date}
                        </AppLabel>
                        <HiOutlineChevronDown style={{fontSize: '2rem', color: '#A0AEC0'}} />
                    </FlexRow>
                </CustomContainer>
            </FlexRow>
            <FlexRow topMargin="6" gap="2" wrap="wrap">
                <CustomContainer width="67" sizeUnit="%" className="login-history-session">
                    <AppLabel fontWeight="600" color="#27272E">Sessions</AppLabel>
                    <CustomContainer 
                        height="30.1" borderColor="#E2E8F0" radius="0.4"
                        padding="1" topPadding="1.5" bottomPadding="1.5"
                    >
                        <SessionChart/>
                    </CustomContainer>
                </CustomContainer>
                <CustomContainer width="30" sizeUnit="%" className="login-history-channels">
                    <AppLabel fontWeight="600" color="#27272E">Channels</AppLabel>
                    <CustomContainer 
                        height="30.1" borderColor="#E2E8F0" radius="0.4"
                        padding="1" topPadding="1.5" bottomPadding="1.5"
                    >
                        <ChannelsChart />
                    </CustomContainer>
                </CustomContainer>
            </FlexRow>
            <CustomContainer topMargin="3.5">
                <Table 
                    tableData={loginHistories}
                    tableColumns={loginHistoryColumns}
                    customStyle
                />
            </CustomContainer>
        </CustomContainer>
    )
}